import { gql } from '@apollo/client';

export const ARCHIVE_POOL = gql`
  mutation ArchivePools($input: ArchivePoolsInput!) {
    archivePools(input: $input) {
      success
      message
      results {
        pool_id
        success
        message
      }
    }
  }
`;
